<template>
  <v-card role="card" flat rounded="lg" :class="{ 'px-6': withPadding }">
    <slot></slot>
  </v-card>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'CardWrapper',

  props: {
    withPadding: {
      type: Boolean,
      default: true
    }
  }
});
</script>
